import Grid from '@material-ui/core/Grid';
import clsx from 'clsx';
import React from 'react';
import PermissionHide from 'v2/components/Shared/PermissionHide';

import { Link } from './Link';
import { useStyles } from './styles';

interface CardProps {
  title: string;
  subtitle: string;
  link: string;
  disabled?: boolean;
  permission?: string;
  userTypes?: string[];
  allowWithoutPermission?: boolean;
  target?: string;
}

const cards: CardProps[] = [
  {
    title: 'Comissões pagas a afiliados',
    subtitle: 'Verifique quanto você já pagou de comissão a seus afiliados.',
    link: '/producer/reports/sales/commissions/affiliates',
    permission: 'myeduzz:reports:visualizar',
  },
  {
    title: 'Comissões pagas a parceiros',
    subtitle: 'Verifique quanto você já pagou de comissão a seus parceiros (coprodutores).',
    link: '/producer/reports/sales/commissions/partners',
    permission: 'myeduzz:reports:visualizar',
  },
  {
    title: 'Reembolsos',
    subtitle: 'Confira os reembolsos realizados em suas vendas. ',
    link: '/producer/reports/sales/refunds',
    permission: 'myeduzz:reports:visualizar',
  },
  {
    title: 'Motivos de Cancelamento',
    subtitle: 'Saiba porque seus contratos têm sido cancelados.',
    link: '/producer/reports/sales/cancel',
    permission: 'myeduzz:reports:visualizar',
  },
  {
    title: 'Chargebacks',
    subtitle: 'Gerencie os chargebacks solicitados pelos clientes.',
    link: '/producer/chargebacks',
    permission: 'myeduzz:chargeback:visualizar',
    userTypes: ['producer'],
  },
  {
    title: 'Sugerir novo relatório',
    subtitle: 'Vote em qual será o próximo relatório a ser disponibilizado ou sugira um novo relatório',
    link: 'https://surveys.hotjar.com/f9ad4cec-c6be-458b-921a-b85083ee27cb',
    allowWithoutPermission: true,
  },
];

export const Cards = () => {
  const classes = useStyles();

  return (
    <Grid container spacing={2}>
      {cards.map((card) => (
        <PermissionHide allowWithoutPermission={card.allowWithoutPermission} userTypes={card.userTypes} action={card.permission} key={card.title}>
          <Grid item className={classes.item} xs={12} sm={6} md={3}>
            <Link className={clsx(classes.paper, card.disabled ? classes.paperDisabled : classes.paperHover)} {...card}>
              <h3 className={classes.title}>{card.title}</h3>
              <p className={classes.subtitle}>{card.subtitle}</p>
            </Link>
          </Grid>
        </PermissionHide>
      ))}
    </Grid>
  );
};
